import React, { useEffect, useRef, useState } from "react";
import { motion } from "framer-motion";
import * as Yup from "yup";
import { useSelector, useDispatch } from "react-redux";
import { useFormik } from "formik";
import FieldInput from "../../Components/FieldInput";
import { GiShoppingBag } from "react-icons/gi";
import { setBuyNowProducts } from '../../Store/Auth/actions'
import { setAlert } from '../../Store/Theme/actions'
import { CiSquareMinus, CiSquarePlus } from "react-icons/ci";
import API from "../../Common/API";
import { useHistory } from 'react-router-dom'
import { IoMdCloseCircle } from "react-icons/io";
import Dialog from "../../Components/Dialog";

const initialDeliveryAddress = {
    name: '',
    mobileNumber: '',
    email: '',
    city: '',
    state: '',
    district: '',
    pinCode: '',
    addressLine1: '',
    landMark: '',
    addressLine2: ''
};

const CheckOut = () => {

    const userDetails = useSelector((state) => state.auth.userDetails)
    const buyNowProducts = [JSON.parse(localStorage.getItem('buyNowProducts'))];
    const changeRef = useRef(null);
    const [orderDetails, setOrderDetails] = useState([])
    const dispatch = useDispatch()
    const history = useHistory()
    const [loading, setLoading] = useState(true)
    const [formData, setFormData] = useState(initialDeliveryAddress)
    const [couponCode, setCouponCode] = useState('')
    const [couponDisabled, setCouponDisabled] = useState(false)
    const [discountValue, setDiscountValue] = useState(0)
    const [couponId, setCouponId] = useState('')
    const [checkoutAddress, setCheckoutAddress] = useState()
    const [openAddress, setOpenAddress] = useState(false)
    const currentDeliveryAddress = useSelector((state) => state.auth.currentDeliveryAddress)

    useEffect(() => {
        API.get('/users/getDeliveryAddress').then((address) => {
            if (address.status === 200 && address.data.data.length > 0) {
                console.log(currentDeliveryAddress)
                setFormData(currentDeliveryAddress ? currentDeliveryAddress : address.data.data.filter((x) => x.defaultAddress)[0])
                setCheckoutAddress(address.data.data)
            }
        })
    }, [])


    const deliveryAddressSchema = Yup.object().shape({
        name: Yup.string().required("Name is required"),
        mobileNumber: Yup.string().required("Mobile Number is required"),
        email: Yup.string().nullable(),
        city: Yup.string().required("City is required"),
        state: Yup.string().required("State is required"),
        district: Yup.string().required("District is required"),
        pinCode: Yup.string().required("Pincode is requried"),
        addressLine1: Yup.string().required("Address Line 1 is required"),
        addressLine2: Yup.string().nullable(),
        landMark: Yup.string().nullable()
    });

    const deliveryAddress = useFormik({
        initialValues: formData,
        validateOnMount: true,
        validationSchema: deliveryAddressSchema,
        enableReinitialize: true,
        onSubmit: (values) => {
            makeOrder(values);
        }
    });

    const totalPrice = () => orderDetails.reduce((total, pro) => {
        return total + ((pro.productData.offerPercentage !== 0 ? pro.productData.price * (pro.productData.offerPercentage / 100) : pro.productData.price) * pro.productData.userOrderQuantity);
    }, 0);

    const totalCGST = () => orderDetails.reduce((total, pro) => {
        return total + ((pro.productData.cgst * pro.productData.userOrderQuantity));
    }, 0);

    const totalSGST = () => orderDetails.reduce((total, pro) => {
        return total + (pro.productData.sgst * pro.productData.userOrderQuantity);
    }, 0);

    const totalDeliveryCharges = () => orderDetails.reduce((total, pro) => {
        return total + (pro.productData.deliveryCharges);
    }, 0);

    const quantitySize = (value, index) => {
        const updatedOrderDetails = [...orderDetails];
        if (value === '-') {
            if (updatedOrderDetails[index].productData.userOrderQuantity > 1) {
                updatedOrderDetails[index].productData.userOrderQuantity -= 1;
            }
        } else {
            updatedOrderDetails[index].productData.userOrderQuantity += 1;
        }
        setOrderDetails(updatedOrderDetails);
        totalPrice()
    };

    useEffect(() => {
        if (buyNowProducts[0].length > 0) {
            setOrderDetails(...buyNowProducts);
        } else {
            setOrderDetails(buyNowProducts);
        }
        setLoading(false)
        // return () => {
        //     localStorage.removeItem('fromWishList')
        //     localStorage.removeItem('buyNowProducts')
        // }
    }, [])// eslint-disable-line

    const makeOrder = async (address) => {
        let apiValues = {
            amount: (totalGrandTotal()) * 100,
            currency: 'INR',
            receipt: `receipt_${Date.now()}`
        };
        const response = await API.post('/payments/create-order', apiValues);

        const options = {
            key: "rzp_test_TM1RDYWkNunikq", // Replace with your Razorpay key ID
            amount: apiValues.amount,
            currency: apiValues.currency,
            name: "Multivendor application ",
            description: "Transaction",
            order_id: response.data.data.id,
            handler: async (response) => {
                const paymentData = {
                    razorpay_order_id: response.razorpay_order_id,
                    razorpay_payment_id: response.razorpay_payment_id,
                    razorpay_signature: response.razorpay_signature,
                    deliveryAddress: address,
                    totalAmount: apiValues.amount,
                    transactionId: response.razorpay_payment_id,
                    transactionBy: userDetails.subject._id,
                    transactionDate: new Date()
                };
                // Call backend API to verify payment and complete order
                const paymentRes = await API.post('/payments/verify', paymentData);
                if (paymentRes.status === 200) {
                    completeOrder(paymentData)
                } else {
                    dispatch(setAlert({ title: 'Error', subtitle: 'Something went wrong. Please try again later', type: 'error', active: true }))
                }
            },
            prefill: {
                name: address.name,
                email: address.email,
                contact: address.mobileNumber
            },
            notes: {
                address: `${address.addressLine1}, ${address.city}, ${address.state}, ${address.pinCode}`
            },
            theme: {
                color: "#3399cc"
            }
        };

        const razorpay = new window.Razorpay(options);
        razorpay.open();
    };


    const completeOrder = async (paymentDetails) => {
        const completeOrderDetails = []
        orderDetails.map((order) => {
            let values = {
                productId: order.productData._id,
                transactionId: paymentDetails.razorpay_payment_id,
                orderId: paymentDetails.razorpay_order_id,
                transactionDate: new Date(),
                orderQuantity: order.productData.orderQuantity,
                userOrderQuantity: order.productData.userOrderQuantity,
                cgst: order.productData.orderQuantity * order.productData.cgst,
                sgst: order.productData.orderQuantity * order.productData.sgst,
                price: order.productData.orderQuantity * order.productData.price,
                sellerId: order.productData.addedBy,
                orderedBy: userDetails.subject._id,
                fromWishList: order.fromWishList,
                fromCart: order.fromCart,
            }
            completeOrderDetails.push(values)
            return order
        })
        const date = new Date()
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
        const day = String(date.getDate()).padStart(2, '0');
        let values = {
            invoiceDetails: completeOrderDetails,
            couponCode: couponCode,
            couponId: couponId,
            orderId: paymentDetails.razorpay_order_id,
            orderDetails: {
                ...deliveryAddress.values,
                totalAmount: paymentDetails.totalAmount,
                orderId: paymentDetails.razorpay_order_id,
                orderPlacedDate: `${year}-${month}-${day}`,
                orderedBy: userDetails.subject._id
            }
        }
        await API.post('/order/completeOrder', values).then((orderRes) => {
            if (orderRes.status === 200) {
                history.push('/')
                dispatch(setAlert({ title: 'Success', subtitle: 'Order Placed Succesfully', type: 'success', active: true }))
                localStorage.removeItem('buyNowProducts')
                dispatch(setBuyNowProducts([]))
            }
        })
    };

    const removeItem = (index) => {
        const updateOrderDetails = [...orderDetails];
        if (updateOrderDetails.length > 1) {
            updateOrderDetails.splice(index, 1);
            setOrderDetails(updateOrderDetails);
            localStorage.setItem('buyNowProducts', JSON.stringify(updateOrderDetails));
        } else {
            dispatch(setAlert({ title: 'Warning', subtitle: 'Order need atleast one product to complete the purchase', active: true, type: 'warning' }))
        }
    }

    const applyCoupon = () => {
        try {
            API.post('/common/checkVerifiedCoupon', { couponCode: couponCode }).then((couponRes) => {
                if (couponRes.status === 200) {
                    dispatch(setAlert({ title: 'Success', subtitle: "Coupon applied successfully", active: true, type: 'success' }))
                    setCouponDisabled(true)
                    setCouponId(couponRes.data.couponId)
                    setDiscountValue(couponRes.data.percentage)
                }
            }).catch((err) => {
                console.log(err)
                dispatch(setAlert({ title: 'Error', subtitle: err.response.data, active: true, type: 'error' }))
            })
        } catch (err) {
        }
    }

    const totalGrandTotal = () => {
        const percentageDeduction = (totalPrice() + (totalPrice() * ((totalCGST() + totalSGST()) / 100)) + totalDeliveryCharges()) * parseInt(discountValue) / 100
        return percentageDeduction > 0 ? (totalPrice() + (totalPrice() * ((totalCGST() + totalSGST()) / 100)) + totalDeliveryCharges()) - percentageDeduction : (totalPrice() + (totalPrice() * ((totalCGST() + totalSGST()) / 100)) + totalDeliveryCharges())
    }

    const totalAmount = () => {
        const total = (totalPrice() + (totalPrice() * ((totalCGST() + totalSGST()) / 100)) + totalDeliveryCharges())
        return total
    }

    const percentageDeduction = () => {
        const percentageDeduction = (totalPrice() + (totalPrice() * ((totalCGST() + totalSGST()) / 100)) + totalDeliveryCharges()) * parseInt(discountValue) / 100
        return percentageDeduction
    }

    const removeCoupon = () => {
        setCouponCode('')
        setCouponDisabled(false)
        setDiscountValue(0)
    }

    const changeQuantitySize = (values, index) => {
        const value = values.length === 0 ? '' : parseInt(values); // Convert string to number
        const updatedOrderDetails = [...orderDetails];
        if (!isNaN(value) && value >= 0) {
            updatedOrderDetails[index].productData.orderQuantity = value;
            setOrderDetails(updatedOrderDetails);
            totalPrice();
        }
    };
    console.log(buyNowProducts)
    return (
        <>
            {
                loading ? "Loading please wait ...." : <motion.div className="relative h-full w-full flex flex-col px-2 md:px-20">
                    <motion.div className="flex flex-col-reverse md:flex-row justify-between w-full relative">
                        <motion.div className="w-full h-fit md:w-2/4 flex flex-col">
                            <motion.div className="text-black my-2 font-md font-bold">
                                Delivery Information
                            </motion.div>
                            <motion.div className="grid bg-white drop-shadow-lg h-full grid-cols-1 sm:grid-cols-1 md:grid-cols-2 xl:grid-cols-2 lg:grid-cols-2">
                                <FieldInput label={'Name'} placeholder={'Enter your name'} fieldProps={deliveryAddress.getFieldProps('name')} fieldHelper={deliveryAddress.getFieldHelpers('name')} fieldMeta={deliveryAddress.getFieldMeta('name')} edit={true} dataLoaded={true} />
                                <FieldInput label={'Mobile Number'} placeholder={'Enter your mobile'} fieldProps={deliveryAddress.getFieldProps('mobileNumber')} fieldHelper={deliveryAddress.getFieldHelpers('mobileNumber')} fieldMeta={deliveryAddress.getFieldMeta('mobileNumber')} edit={true} dataLoaded={true} />
                                <FieldInput label={'Email'} placeholder={'Enter your email'} fieldProps={deliveryAddress.getFieldProps('email')} fieldHelper={deliveryAddress.getFieldHelpers('email')} fieldMeta={deliveryAddress.getFieldMeta('email')} edit={true} dataLoaded={true} />
                                <FieldInput label={'Address Line 1'} placeholder={'Enter your addressline1'} fieldProps={deliveryAddress.getFieldProps('addressLine1')} fieldHelper={deliveryAddress.getFieldHelpers('addressLine1')} fieldMeta={deliveryAddress.getFieldMeta('addressLine1')} edit={true} dataLoaded={true} />
                                <FieldInput label={'Address Line 2'} placeholder={'Enter your addressLine2 (optional)'} fieldProps={deliveryAddress.getFieldProps('addressLine2')} fieldHelper={deliveryAddress.getFieldHelpers('addressLine2')} fieldMeta={deliveryAddress.getFieldMeta('addressLine2')} edit={true} dataLoaded={true} />
                                <FieldInput label={'City/Town'} placeholder={'Enter your city/town'} fieldProps={deliveryAddress.getFieldProps('city')} fieldHelper={deliveryAddress.getFieldHelpers('city')} fieldMeta={deliveryAddress.getFieldMeta('city')} edit={true} dataLoaded={true} />
                                <FieldInput label={'District'} placeholder={'Enter your district'} fieldProps={deliveryAddress.getFieldProps('district')} fieldHelper={deliveryAddress.getFieldHelpers('district')} fieldMeta={deliveryAddress.getFieldMeta('district')} edit={true} dataLoaded={true} />
                                <FieldInput label={'Landmark'} placeholder={'Enter your landmark'} fieldProps={deliveryAddress.getFieldProps('landMark')} fieldHelper={deliveryAddress.getFieldHelpers('landMark')} fieldMeta={deliveryAddress.getFieldMeta('landMark')} edit={true} dataLoaded={true} />
                                <FieldInput label={'Pincode'} placeholder={'Enter your Pincode'} fieldProps={deliveryAddress.getFieldProps('pinCode')} fieldHelper={deliveryAddress.getFieldHelpers('pinCode')} fieldMeta={deliveryAddress.getFieldMeta('pinCode')} edit={true} dataLoaded={true} />
                                <FieldInput label={'State'} placeholder={'Enter your state'} fieldProps={deliveryAddress.getFieldProps('state')} fieldHelper={deliveryAddress.getFieldHelpers('state')} fieldMeta={deliveryAddress.getFieldMeta('state')} edit={true} dataLoaded={true} />
                            </motion.div>
                            <motion.div className="text-primeColor my-5 font-bold cursor-pointer" onClick={() => setOpenAddress(true)}>
                                Change Address
                            </motion.div>
                        </motion.div>
                        <motion.div className="w-full min-h-screen relative md:w-2/4 px-2 flex flex-col">
                            <motion.div className="text-black my-2 font-md font-bold">
                                Order Summary
                            </motion.div>
                            <motion.div className="h-screen relative bg-white relative drop-shadow-lg">
                                {
                                    orderDetails.map((prod, prodId) => {
                                        return <motion.div key={prodId} className="flexflex-col">
                                            <motion.div className="grid grid-cols-2 gap-10" >
                                                <motion.div className="flex flex-row px-2 py-2">
                                                    <img src={prod?.imageData[0].imageUrl} height={60} width={60} alt="orderPreview" />
                                                    <motion.div className="flex flex-col px-2 mx-2">
                                                        {prod.productData.productName}<br />
                                                        {prod.productData.offerPercentage !== 0 ? prod.productData.price * (prod.productData.offerPercentage / 100) : prod.productData.price}
                                                    </motion.div>
                                                </motion.div>
                                                <motion.div className="flex w-full items-center justify-end flex-row">
                                                    <CiSquareMinus className="text-3xl font-bold" onClick={() => prod.productData.userOrderQuantity > 1 && quantitySize('-', prodId)} />
                                                    <input
                                                        ref={changeRef}
                                                        type="number"
                                                        min="1"
                                                        style={{ WebkitAppearance: 'none', MozAppearance: 'textfield' }}
                                                        className="w-12 ring-1 items-center justify-center flex flex-row ring-[black] px-2"
                                                        value={prod.productData.userOrderQuantity}
                                                        onChange={(ev) => changeQuantitySize(ev.target.value, prodId)}
                                                    />
                                                    <CiSquarePlus className="text-3xl font-bold" onClick={() => quantitySize('+', prodId)} />
                                                    <IoMdCloseCircle className="text-2xl text-[red] mx-2" onClick={() => removeItem(prodId)} />
                                                </motion.div>
                                            </motion.div>
                                            <motion.div className="h-[1px] w-full bg-[lightGrey]" />
                                        </motion.div>
                                    })
                                }
                                <motion.div className="text-black bottom-0 absolute  w-full px-2 py-2 relative md:absolute font-bold flex flex-col">
                                    <motion.div className="text-md font-bold">
                                        Price Summary
                                    </motion.div>
                                    <motion.div className="flex flex-row py-2 justify-between w-full">
                                        <p>Total</p>
                                        <p>{totalPrice()}</p>
                                    </motion.div>
                                    <motion.div className="flex flex-row py-2 justify-between w-full">
                                        <p>CGST</p>
                                        <p>{totalCGST()}</p>
                                    </motion.div>
                                    <motion.div className="flex flex-row py-2 justify-between w-full">
                                        <p>SGST</p>
                                        <p>{totalSGST()}</p>
                                    </motion.div>
                                    <motion.div className="flex flex-row py-2 justify-between w-full">
                                        <p>Delivery Charges</p>
                                        <p>{totalDeliveryCharges()}</p>
                                    </motion.div>
                                    <motion.div className="flex flex-col py-2 justify-between w-full">
                                        <p>{couponCode && discountValue ? 'Applied Coupon' : 'Apply Coupon'}</p>
                                        {couponCode && discountValue ? <motion.div className="flex flex-row w-full">
                                            <input type="text" disabled={couponDisabled} className="flex flex-row items-center py-2 px-2 text-[grey] font-bold" placeholder="Apply Coupon" onChange={(ev) => setCouponCode(ev.target.value)} value={couponCode} />
                                            <motion.div className="text-[red] flex flex-col justify-center items-center mx-2 cursor-pointer" onClick={() => removeCoupon()}>X</motion.div>
                                        </motion.div> : <motion.div className="flex flex-row w-full">
                                            <input type="text" disabled={couponDisabled} className="flex flex-row w-full items-center py-2 px-2 text-black font-bold border border-black" placeholder="Apply Coupon" onChange={(ev) => setCouponCode(ev.target.value)} value={couponCode} />
                                            <motion.div className="bg-primeColor/40 hover:bg-primeColor hover:text-white w-32 flex flex-col justify-center items-center mx-2 cursor-pointer" onClick={() => applyCoupon()}>Apply</motion.div>
                                        </motion.div>}
                                    </motion.div>
                                    {discountValue ? <>
                                        <motion.div className="flex flex-row py-5 justify-between w-full">
                                            <p>Total Amount</p>
                                            <p>{totalAmount()}</p>
                                        </motion.div>
                                        <motion.div className="flex flex-row py-2 justify-between w-full">
                                            <p>Discount Value</p>
                                            <p>-{percentageDeduction()}</p>
                                        </motion.div>
                                    </> : ""}
                                    <motion.div className="h-[1px] w-full bg-[lightGrey]" />
                                    <motion.div className="flex flex-row py-5 justify-between w-full">
                                        <p>Net Amount</p>
                                        <p>{totalGrandTotal()}</p>
                                    </motion.div>
                                    <motion.div className="h-[1px] w-full bg-[lightGrey]" />
                                </motion.div>
                            </motion.div>
                        </motion.div>
                    </motion.div>
                    <motion.div className="flex flex-row w-full my-5 justify-center items-center">
                        <motion.div className="bg-primeColor/40 text-black hover:bg-primeColor hover:text-white w-60 text-xl font-bold cursor-pointer items-center justify-center flex flex-row px-5 py-2" onClick={() => deliveryAddress.submitForm()}>
                            <GiShoppingBag className="mx-2" />&nbsp;Confirm Order
                        </motion.div>
                    </motion.div>
                </motion.div>
            }
            <Dialog title="Change Address" injectClass={'w-[420px]'} showDialog={openAddress} onClose={() => setOpenAddress(false)}>
                <motion.div className="grid grid-cols-1 gap-2 h-auto overflow-y-scroll my-2 w-full">
                    {checkoutAddress && checkoutAddress.map((address, i) => {
                        return <motion.div key={i} className="w-full cursor-pointer rounded-xl px-5 py-2 min-h-20 h-auto border border-grey drop-shadow-md" onClick={() => { setFormData(address); setOpenAddress(false) }}>
                            <p className="font-bold">{address.name}</p>
                            <motion.div className="w-full flex flex-row flex-wrap">
                                <p>{address.addressLine1},</p>{address.addressLine2 && <p>{address.addressLine2},</p>}
                                <p>{address.city},</p><p>{address.district} - {address.pinCode},</p><p>{address.state}</p>
                            </motion.div>
                            <p className="font-bold">{address.mobileNumber}</p>
                        </motion.div>
                    })}
                </motion.div>
            </Dialog>
        </>
    )
}

export default CheckOut